
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/workspace-management/roles",
      function () {
        return require("private-next-pages/workspace-management/roles.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/workspace-management/roles"])
      });
    }
  